"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RadioGroup = _interopRequireDefault(require("./RadioGroup.style"));
var _Radio = _interopRequireDefault(require("./Radio"));
var _InputError = _interopRequireDefault(require("../errors/InputError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var defaultoptions = [{
  value: 'yes'
}, {
  value: 'no',
  iconChecked: 'ion-close',
  iconUnchecked: 'ion-close'
}];
var RadioGroup = function RadioGroup(_ref) {
  var selectedValue = _ref.selectedValue,
    onChange = _ref.onChange,
    name = _ref.name,
    errors = _ref.errors,
    disabled = _ref.disabled,
    className = _ref.className,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? defaultoptions : _ref$options;
  return /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
    className: "radio-group-wrapper ".concat(className)
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({
      key: option.value
    }, option, {
      name: name,
      disabled: disabled,
      checked: option.value === selectedValue,
      onChange: onChange
    }));
  }), errors && Array.isArray(errors) ? errors.map(function (error, index) {
    return error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
      key: "".concat(index, "-").concat(error),
      id: "".concat(name, "Error").concat(index),
      message: error
    });
  }) : errors && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    message: errors,
    id: "".concat(name, "Error0")
  }));
};
RadioGroup.propTypes = {
  disabled: _propTypes["default"].bool,
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  selectedValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  className: _propTypes["default"].string
};
RadioGroup.defaultProps = {
  selectedValue: '',
  errors: '',
  onChange: function onChange() {},
  name: '',
  disabled: false,
  options: undefined,
  className: ''
};
RadioGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RadioGroup",
  "props": {
    "options": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false
    },
    "selectedValue": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "name": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = RadioGroup;
exports["default"] = _default;